import { Injectable, Provider } from '@angular/core';
import { ISearchServiceToken } from 'projects/shared/lib/services/ui/search/search-service.interface';
import { SearchState } from 'projects/shared/lib/services/ui/search/search-state.model';
import { SearchService } from 'projects/shared/lib/services/ui/search/search.service';

@Injectable({
  providedIn: 'root'
})
export class SearchMHService extends SearchService {

  public searchStateSet(searchState: SearchState, doNavigation: boolean) {

    let searchTermChanged =
      (this.searchState.searchTerm != undefined && searchState.searchTerm == undefined)
      || (this.searchState.searchTerm == undefined && searchState.searchTerm != undefined)
      || (this.searchState.searchTerm != undefined && searchState.searchTerm != undefined && (this.searchState.searchTerm.localeCompare(searchState.searchTerm) != 0));

    if (!searchTermChanged) {
      return;
    }

    this.searchState = searchState;
    this.searchStateSubject.next(this.searchState);

    if (doNavigation == false) {
      return;
    }

    if (searchState.searchTerm != undefined && searchState.searchTerm.length > 0) {
      this.router.navigate(["product", "search"], {
        queryParams: {
          searchText: searchState.searchTerm
        }
      });
    }
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SearchMHServiceProvider: Provider[] = [
  { provide: ISearchServiceToken, useExisting: SearchMHService }
];
